<template>
  <div class="control_bar top">
    <controller
      :dispItems="dispItems"
      :allItems="userNotification"
      :router="router"
      @remove="remove"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      showFinishModal: false,
      finishWord: '',
      router: '/userNotification/add',
      showloadingModal: false
    }
  },
  computed: {
    userNotification() {
      return this.$store.state.userNotification.userNotification
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedUserNotificationList() {
      return this.$store.state.userNotification.selectedUserNotificationList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedUserNotificationIdList = this.selectedUserNotificationList.map(
        userNotification => userNotification.id
      )
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'userNotification/deleteUserNotifications',
          selectedUserNotificationIdList
        )
        this.$store.dispatch(
          'userNotification/clearSelectedUserNotificationList'
        )
        this.finishWord = '対象のお知らせを削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/userNotification') {
          this.$router.push('/userNotification')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 3
        let reason = 'MSGCRC0322'
        if (error.response) {
          this.finishWord =
            this.errorMsg.MSGCRC0322.name +
            this.errorMsg.MSGCRC0322.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.controller >>> .uploader,
.controller >>> .txt,
.controller >>> .column_import,
.controller >>> .column_export {
  color: #bbb;
  pointer-events: none;
}
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/userNotification/controlbar.vue